import React from 'react';
import '../../styles/education.css';
import PageHeading from '../page-heading';
import { FaGraduationCap ,FaWordpress,FaCode  } from "react-icons/fa";
import AOS from 'aos';
import 'aos/dist/aos.css';
const Education = () => {
    AOS.init();
    const educationDetail = [
        {
            icon: <FaGraduationCap />,
            year: "2015-2020",
            title: "Matriculation",
            description: "In 2020, I  completed my Matriculation exams at Government High School Mithi Tharparkar Institute.",
            fade:"fade-left"
        },
        {
            icon: <FaGraduationCap />,
            year: "2020-2022",
            title: "Intermediate",
            description: "In 2022, I graduated from Sadique Faqeer Government Boys Degree College, Mithi Tharparkar.",
            fade:"fade-right"
        },
        {
            icon: <FaCode  />,
            year: "2022-2024",
            title: "Web Development",
            description: " Understand the technology of building website I learned Web Development at Ihunar IT Training Company Mithi.",
            fade:"fade-left"
        },
        {
            icon: <FaWordpress />,
            year: "2024",
            title: "WordPress Development",
            description: "I learned WordPress from Digiskill, gaining expertise in using various plugins and themes to create dynamic and functional websites.",
            fade:"fade-right"
        },
        {
            icon: <FaGraduationCap />,
            year: "2026",
            title: "Bachelor’s in Software Engineering",
            description: "Started my bachelor's degree in software engineering at Sindh University, Jamshoro.",
            fade:"fade-right"
        },
    ]
    return (
        <div>
            <PageHeading heading="My Education" />
            <div className="container">
                <div className="row">
                    <div className="col-12">
                    <div className="main-timeline">
                        {educationDetail.map((item,index) => {
                            return (
                                <div className="timeline" data-aos={item.fade} key={index}>
                                    <div className="timeline-content">
                                        <div className="timeline-icon">{item.icon}</div>
                                        <div className="timeline-year">{item.year}</div>
                                        <h3 className="title">{item.title}</h3>
                                        <p className="description">{item.description} </p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
            </div>
                </div>
            </div>
        </div>
    )
}

export default Education;
